import React from 'react';

import View from './view';
import {useDispatch, useSelector} from 'react-redux';
import {
  holderProfileSelector,
  profileNotificationsByIdSelector,
  profileNotificationsSelector,
} from '../../redux/selectors/profile';
import {DeviceSize, useDeviceSize} from '../../shared/theme/helpers';
import {NotificationDesktop} from '../notification/desktop';
import {useModal} from '../../shared/components/modal';
import {Screens} from '../../shared/routing';
import {useFocusEffect, useNavigation, useRoute} from '@react-navigation/native';
import {latestNewsSelector} from '../../redux/selectors/news';
import {NavigationRouteProps} from '../../shared/routing/model';
import {useNotificationPressHandler} from '../notification/hooks/useNotificationPressHandler';
import {getProfileNotifications} from '../../redux/actions/profile';

const MainScreen = () => {
  const dispatch = useDispatch();
  const deviceSize = useDeviceSize();
  const profile = useSelector(holderProfileSelector());
  const notifications = useSelector(profileNotificationsSelector());
  const latestNews = useSelector(latestNewsSelector());
  const modal = useModal();
  const navigation = useNavigation();
  const route: NavigationRouteProps<{id: string}> = useRoute();
  const notificationId = +route?.params?.id;
  const notification = useSelector(profileNotificationsByIdSelector(notificationId));
  const notificationPressHandler = useNotificationPressHandler(notification, navigation);

  const handleFocus = React.useCallback(() => {
    dispatch(getProfileNotifications());
  }, []);

  useFocusEffect(handleFocus);

  React.useEffect(() => {
    if (deviceSize === DeviceSize.desktop && notificationId) {
      modal.show({
        render({id: modalId}, methods) {
          const handleClose = () => {
            methods.remove(modalId);
            navigation.navigate(Screens.Main, {id: '', tab: ''});
          };
          const handlePress = notificationPressHandler
            ? () => {
                methods.clear();
                notificationPressHandler();
              }
            : null;

          return React.createElement(NotificationDesktop, {
            onModalClose: handleClose,
            onNotificationPress: handlePress,
            id: notificationId,
            navigation,
          });
        },
      });
    }
    return () => {
      const lastModal = modal.getLast();
      if (lastModal) modal.remove(lastModal.id);
    };
  }, [deviceSize, notificationId, notificationPressHandler]);

  return <View notifications={notifications} profile={profile} latestNews={latestNews} />;
};

export default MainScreen;
